// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		var rellax = new Rellax('.rellax',{center:true});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});
		
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		var start = $('#arriveInput').attr('value');
		var end = $('#departureInput').attr('value');
		var firstClick = 0; 

		var limitDate = $('#limitDate').attr('value').split(',');

		$('#datesCalendar').datepicker({
			minDate: start,
			numberOfMonths:2,
			dateFormat: 'yy-mm-dd',
			maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
			beforeShowDay:function(date){

				$.datepicker._defaults.dateFormat = "yy-mm-dd";
				var startDate = $.datepicker.parseDate('yy-mm-dd', start);
				var endDate = $.datepicker.parseDate('yy-mm-dd', end);
				
				if(date.getTime() == startDate.getTime()){
					return[true,"start-day"];
				} else {
					if(date.getTime() == endDate.getTime()){
						return[true,"end-day"];
					} else {
						if(date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()){
							return[true,"days"];
						} else {
							return[true,""];
						}
					}
				}
			},
			onSelect: function(date){
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if(firstClick == 0){
					start = date;
					end = date;
					firstClick = 1;
				} else {
					if(selectedDate <= start){
						end =  start;
						start = date;  
					} else {
						end =  date; 
					}
					firstClick = 0;
				}

				$('#arriveInput').attr('value',start);
				$('#departureInput').attr('value',end);
				console.log("Selected date: " + start + "; input's current value: " + end);
				$("#pickup").val(start + "   /   " + end);		
				
			},
			onChangeMonthYear: function(){
				setTimeout(function(){
					calendarH();
				},80)
			}
		});
		var booking_date_format = 'yy-mm-dd';
		var booking_min_date = '';
		var booking_allow_children = false;
		$("#pickup").mask("Z9-Z9-9999   -   Z9-Z9-9999", {
			translation: {
			"Z": {
				pattern: /[0-9]/, optional: true
			}
			}
		});
		$("#pickup").daterangepicker({
			// minDate: new Date(),
			minDate: booking_min_date ? booking_min_date : new Date(),
			opens: "center",
			drops:"down",			
			alwaysShowCalendars:true,
			autoApply:true,
			autoUpdateInput:false,
			locale: {
				format:"YYYY-M-D",
				"monthNames": [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December"
				],
				"daysOfWeek": [
					"Sun",
					"Mon",
					"Tue",
					"Wed",
					"Thu",
					"Fri",
					"Sat"
				],
			}
		}, function(start, end, label) {
			updateDataPicker(start,end);
			$("#pickup").val(start.format("YYYY-M-D") + "   /   " + end.format("YYYY-M-D"));
			/*Validate less date */
			var date_in_pick = $("#pickup").val().split("-")
			var dateSelected = new Date(date_in_pick[0]);
			var dateToday = new Date();
			dateSelected.setHours(0,0,0,0);
			dateToday.setHours(0,0,0,0);
		});
		$("#pickup").on("apply.daterangepicker", function(ev, picker) {
			updateDataPicker(picker.startDate,picker.endDate);
			$(this).val(picker.startDate.format("YYYY-M-D") + "   -   " + picker.endDate.format("YYYY-M-D"));
		});
		function updateDataPicker(start,end){			
			var date_in1 = new Date(start.format("YYYY-MM-DD"));
			var date_in2 = new Date(end.format("YYYY-MM-DD"));
			var a = start.format(booking_date_format);
			var b = end.format(booking_date_format);
			$("#CheckIn").val(a);
			$("#CheckOut").val(b);
			$("#nights").val((Math.abs((date_in1-date_in2)/86400000)) + " Nights");
		};
		$("#pickup").on("cancel.daterangepicker", function(ev, picker) {
			$(this).val("");
			$( "#nights" ).val("0 Nights");
		});


		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		$('.sign-up .signup-btn').appendTo('.sign-up .gdpr-wrap');

		//Accomodations filter
		$('.accommodations__filter ul li').click(function () {
			const thisTag = $(this).attr('data-tag');
			console.log(thisTag);
			$('.grid__col').hide();
			$('.' + thisTag).fadeIn();
			$('.accommodations__filter ul li').removeClass('active');
			$(this).addClass('active');
		})
		if ($(window).width() >= 575){
			$('.accommodations__filter ul li:first-child').click();
		}
		
	
		$('#acc-select').on("change", function(){
			const thisTag = $(this).val();
			console.log(thisTag);
			$('.grid__col').hide();
			$('.' + thisTag).fadeIn();
		})

		//accommodations links
		$('.tag-link').click(function(e){
			e.preventDefault();
			let self = $(this);
			let currentTarget = $(this).attr('href');
			console.log(currentTarget);
			if(currentTarget == '#all'){
				$('.accommodations-block').each(function(){
					$(this).fadeIn();
				});
			} else {
				let currentTag = currentTarget.split('#')[1];
	
				$('.accommodations-block').each(function(){
					if($(this).attr('id') == currentTag){
						$(this).fadeIn();
					} else {
						$(this).fadeOut();
					}
				});
			}
			
			$('.tag-link').each(function(){
				if($(this).attr('href') === currentTarget){
					$(this).addClass('active');
				} else {
					$(this).removeClass('active');
				}
			});
		})
	
	
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');
	if(document.getElementById('gallery') || document.getElementById('attractions')){
		
		document.getElementById('header').classList.add('down');
		document.getElementById('header').classList.remove('up');
		document.getElementById('img-logo').src = '/assets/images/logo-icon.png';
		

	} else {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			lineAnimation();
		})
	}
		
		

		document.querySelector('.js-booking').addEventListener('click', function(e){
			e.preventDefault();
			document.querySelector('.booking-block').classList.add('open');
		})
		document.querySelector('.js-close').addEventListener('click', function(e){
			e.preventDefault();
			document.querySelector('.booking-block').classList.remove('open');
		})
	};

}());

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

function lineAnimation() {
	var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
	var footer = document.querySelector(".footer");
	var signUp =  document.querySelector('.sign-up');
	//console.log(signUp.offsetHeight);
	var scrolled = winScroll;
	if ((window.innerHeight + window.scrollY) <= (document.body.offsetHeight - footer.offsetHeight - 100)) {
		document.getElementById("myBar").style.height = scrolled + "px";
	}
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let logo =  document.getElementById('img-logo');
	let logoColor = "/assets/images/logo.png";
	let logoWhite = "/assets/images/logo-icon.png";

	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				logo.src = logoWhite;

			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			logo.src = logoColor;

		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}